import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../Assets/logo.webp";
import { useState } from "react";
import { MenuList } from "./Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { AppBar, Toolbar } from "@mui/material";
import LogoutModal from "./LogoutModal";

const drawerWidth = 240;

function Layout({ element }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const drawer = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "164px",
            height: "110px",
            p: 2,
          }}
        >
          <img src={logo} height={"100%"} width={"100%"} alt="Logo" srcSet="" />
        </Box>
      </Box>
      <Box
        sx={{
          height: "calc(100vh - 140px)",
          overflow: "scroll",
        }}
        className="sideBar"
      >
        <List
          sx={{
            "&.MuiList-root": {
              paddingTop: 0,
              paddingBottom: 0,
              padding: "0 0.5rem",
            },
          }}
        >
          {MenuList.map(({ Aicon, icon, title, url }, index) => (
            <ListItem
              key={index}
              disablePadding
              onClick={() => navigate(url)}
              sx={{
                my: 0.5,
                background: pathname === url ? "#F57C00" : "white",
                color: pathname === url ? "white" : "#000",
                borderRadius: "12px",
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <img
                    src={pathname === url ? Aicon : icon}
                    style={{
                      height: "24px",
                      width: "24px",
                      objectFit: "cover",
                    }}
                    alt="Icon"
                    srcSet=""
                  />
                </ListItemIcon>
                <ListItemText primary={title} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>

      <Box sx={{ height: "80px" }}>
        <LogoutModal />
      </Box>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          display: { sm: "none" },
        }}
      >
        <Toolbar sx={{ background: "grey" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth } }}
        aria-label="mailbox folders"
      >
        {/* Sidebar code for mobile screen */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        {/* SideBar code on full screen */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {/* <Toolbar /> */}

          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          width: `calc(100%  - ${drawerWidth}px)`,
          minHeight: "100vh",
          boxSizing: "border-box",
          color: "#000",
          background: "#F4F4F4",
        }}
      >
        {element}
      </Box>
    </Box>
  );
}

export default Layout;
